import styles from "../styles/productspanel.module.css";

const PanelSkeleton = ({ count = 1 }) => {
  return (
    <div className={styles.skeletoncont}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="paneldet">
          <div className={`skeleton ${styles.mainImg}`}></div>
          <div className={`skeleton ${styles.first}`}></div>
          <div className={`skeleton ${styles.second}`}></div>
        </div>
      ))}
    </div>
  );
}

export default PanelSkeleton;
